export default __webpack_public_path__ + "static/blog14-e8529a87b61c26466e71d1a9effecdca.jpg";